<!-- /* eslint-disable @angular-eslint/template/no-negated-async */ -->
<div class="page-wrapper-container">
    <div class="table-controls-container">
      <div class="header-container">
        <div class="text-title-2">Messages</div>
        <div class="subheader" *ngIf="dataLength > 1">
          There are
          <div class="bold">{{dataLength}}</div>
         Messages
        </div>
        <div class="subheader" *ngIf="dataLength === 1">
         There is a Message
        </div>
      </div>
  
      <div class="table-controls" *ngIf="dataLength > 0">
        <app-search-input
                          [hideDropdown]="true"
                          [placeholder]="'Search messages'"
                          (searchValueChanged)="searchValueChanged($event)"
        ></app-search-input>
      </div>
    </div>
   <div *ngIf="dataLength > 0; else emptyTable">
    <app-generic-table
        [ngStyle]="{'--table-height': 'calc(100vh - 263px)'}"
        [data]="filtered$ | async" 
        [columns]="columns"
        [withDetailsOption]="false"
        [template]="messages"
        (deleted)="deleteMessage($event)"
    ></app-generic-table>

    <ng-template #messages let-item let-i="index">
       <div class="message-container" (click)="readMore(item)">
        <div class="heading text-base mb-1" [class.read]="item?.readOn">
           {{item?.title}}
        </div>
        <div class="secondary body">
            {{item?.body}}
        </div>
       </div>
    </ng-template>
   </div>
   <ng-template #emptyTable>
    <app-empty-table *ngIf="(loading$ | async) !== true"
                         [labelValue]="'You do not have any messages yet'"
    ></app-empty-table>
  </ng-template>
  </div>

  

  <app-dialog
    [show]="expandedMessage"
    [showHeader]="true"
    [header]="expandedMessage?.title"
    [subHeader]="expandedMessage?.body"
    [headerIcon]="'warning'"
    [headerIconName]="!expandedMessage?.readOn ? 'icon-message-big' : 'icon-message-read'"
    headerIconClasses="!pr-6"
    [minWidth]="720"
    [maxWidth]="720"
    [hideHeaderUnderline]="true"
    >
        <div style="margin-left: 4.5rem;">
            <app-button customClasses="px-5"
                [minWidth]="0"
                [text]="'Got it'"
                (clicked)="gotIt(expandedMessage)"
            ></app-button>
        </div>
  </app-dialog>

  <app-warning-dialog [show]="showDeleteConfirmationDialog$ | async"
                    header="Are you sure you want to do this?"
                    description="After deletion, message will be lost."
                    acceptBtnText="Yes, delete"
                    (cancel)="showDeleteConfirmationDialog$.next(false)"
                    (next)="deleteConfirmed()"
  ></app-warning-dialog>


